import { render, staticRenderFns } from "./BidApprovedetail.vue?vue&type=template&id=5d388e16&scoped=true&"
import script from "./BidApprovedetail.vue?vue&type=script&lang=js&"
export * from "./BidApprovedetail.vue?vue&type=script&lang=js&"
import style0 from "./BidApprovedetail.vue?vue&type=style&index=0&id=5d388e16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d388e16",
  null
  
)

export default component.exports